import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import * as CryptoJS from 'crypto-js';
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';
// import { DxTextBoxModule, DxTextBoxTypes } from 'devextreme-angular/ui/text-box';
// import { DxButtonTypes } from 'devextreme-angular/ui/button';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss']
})
export class SetPasswordComponent implements OnInit {
  passwordMode: string = "password";
  passwordButtons1: { icon: string; stylingMode: string; onClick: () => void; };
  passwordButtons2: { icon: string; stylingMode: string; onClick: () => void; };
  passwordMode2: string = "password";
  passwordButtons3: { icon: string; stylingMode: string; onClick: () => void; };
  passwordButtons4: { icon: string; stylingMode: string; onClick: () => void; };
  showIcon: boolean = true;
  showIcon2: boolean = true;
  //pm: { name: string; location: string; options: { icon: string; type: string; onClick: () => void; }; }[];

  constructor(private toasterService: ToasterService, private router: Router, private config: ConfigService, private loginService: LoginService) {
    this.userData = JSON.parse(this.config.userData);
    console.log(this.userData);   

    this.passwordButtons1 = {
      icon: 'fa fa-eye',
      stylingMode: 'text',
      onClick: () => {
        this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
        this.showIcon = !this.showIcon;
      },
    };

    this.passwordButtons2 = { 
      icon: 'fa fa-eye-slash',
      stylingMode: 'text',
      onClick: () => {
        this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
        this.showIcon = !this.showIcon;
      },
    };

    this.passwordButtons3 = {
      icon: 'fa fa-eye',
      stylingMode: 'text',
      onClick: () => {
        this.passwordMode2 = this.passwordMode2 === 'text' ? 'password' : 'text';
        this.showIcon2 = !this.showIcon2;
      },
    };

    this.passwordButtons4 = { 
      icon: 'fa fa-eye-slash',
      stylingMode: 'text',
      onClick: () => {
        this.passwordMode2 = this.passwordMode2 === 'text' ? 'password' : 'text';
        this.showIcon2 = !this.showIcon2;
      },
    };
  }

  //strongPattern : any = "(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}$/)"
  lowerCase : string = "^(?=[^a-z]*[a-z])";
  upperCase : string = "^(?=[^A-Z]*[A-Z])";
  numberCase : string = "^(?=[^0-9]*[0-9])";
  splChar : string =  "(?=.*[~`!@#$%^&*()-+={}:;'<>,.?/_₹])" ;      ////"(?=.*[!@#$%^&*])"  ;      
  newPassword: any = '';
  confPassword: any = '';
  userData = [];

  ngOnInit() {
    this.config.getLocalStorageData();
    this.userData = JSON.parse(this.config.userData);
    console.log(this.userData)
  }

  passwordComparison = () => this.newPassword;

  encryptField(entity) {
    var key = CryptoJS.enc.Base64.parse('2b7e151628aed2a6abf7158809cf4f3c'); //new key
    var iv = CryptoJS.enc.Base64.parse('S4duQOLzqeKP3rf8nSb5Ow==');          //new iv

    var encrypted = CryptoJS.AES.encrypt(entity, key, { iv: iv });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }

  setPassword(e) {

    let result = e.validationGroup.validate();
    if(result.isValid){
     let password = this.encryptField(this.confPassword);
     
     this.loginService.sendOTPForSignUp(this.userData['mobNumber'], this.userData['countryCode'],this.constructor.name).subscribe(result => {
      //console.log(result);

      if(result['message'].code == 0){
        localStorage.setItem("password", password);
        this.router.navigate(['fynd-verify-otp']);
      }else if(result['message'].code == 1){
        this.toasterService.pop("error", result['message'].message)
      }else if(result['message'].code == 1005){
        this.toasterService.pop("error","Authtoken not valid!")
      }else if(result['message'].code == 4006){
        this.toasterService.pop("error","Requested data not found!")
      }else{
        this.toasterService.pop(result['message'].message)
      }
     })
    }else{
      this.toasterService.pop("error", "Invalid Password!")
    }
  }
 
}
